module.exports = __webpack_public_path__ + "static/img/logo-white.c31fb63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white.png
// module id = 180
// module chunks = 1